export default () => {
  const buildId = process.env.BUILD_ID

  if (!buildId || typeof window === 'undefined') return

  window.__CERTIAPP_BUILD__ = buildId
  console.info(`[certiapp] build ${buildId}`)
}
